import React, { useEffect } from 'react';
import { 
    CheckCircle2, 
    AlertCircle, 
    Info, 
    AlertTriangle, 
    X 
} from 'lucide-react';
import './Common.css';

const Toast = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 5000);
        return () => clearTimeout(timer);
    }, [onClose]);

    const icons = {
        success: <CheckCircle2 className="toast-icon success" />,
        error: <AlertCircle className="toast-icon error" />,
        info: <Info className="toast-icon info" />,
        warning: <AlertTriangle className="toast-icon warning" />
    };

    return (
        <div className={`toast-message toast-${type}`}>
            {icons[type]}
            <span className="toast-text">{message}</span>
            <button className="toast-close" onClick={onClose}><X size={14} /></button>
            <div className={`toast-progress toast-progress-${type}`} />
        </div>
    );
};

export default Toast;
